import React from 'react';

import {
  CheckCircleOutline as CheckCircleIcon,
  ErrorOutline as ErrorIcon,
  Warning as WarningIcon,
} from '@mui/icons-material';
import type { Theme } from '@mui/material';

import { SnackVariant, SnackVariantKey } from '@clearverify/constants';

import { buildStyles } from './styles';

export const getIcons = (theme: Theme) => {
  const { iconsStyles } = buildStyles(theme);

  return {
    [SnackVariant.success]: React.createElement(CheckCircleIcon, {
      sx: iconsStyles.success,
      viewBox,
    }),
    [SnackVariant.info]: React.createElement(ErrorIcon, { sx: iconsStyles.info, viewBox }),
    [SnackVariant.warning]: React.createElement(WarningIcon, { sx: iconsStyles.warning, viewBox }),
    [SnackVariant.error]: React.createElement(CheckCircleIcon, { sx: iconsStyles.error, viewBox }),
  } satisfies Record<SnackVariantKey, React.ReactNode>;
};

const viewBox = '0 0 24 24';
